<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    created(){

      //用户刷新之后，需要检测sessionStorage里面的session_carData、session_accountData是否有值，如果有值，需要根据sessionStorage同步更新vueX中的carData、accountData
      var sessionCarData = JSON.parse( sessionStorage.getItem("session_carData") );
      if( sessionCarData && sessionCarData.length > 0 ){
        this.$store.commit("checkAllCarData",sessionCarData);//根据sessionStorage替换整个vueX中carData
      }

      var sessionAccountData = JSON.parse( sessionStorage.getItem("session_accountData") );
      if( sessionAccountData && sessionAccountData.length > 0 ){
        this.$store.commit("checkAllAccountData",sessionAccountData);//根据sessionStorage替换整个vueX中accountData
      }

      var sessionProductWarranty = JSON.parse( sessionStorage.getItem("session_productWarranty") );
      if( sessionProductWarranty && sessionProductWarranty.length > 0 ){
        this.$store.commit("checkAllProductWarranty",sessionProductWarranty);//根据sessionStorage替换整个vueX中productWarranty
      }

      var sessionproductAuthorize = JSON.parse( sessionStorage.getItem("session_productAuthorize") );
      if( sessionproductAuthorize && sessionproductAuthorize.length > 0 ){
        this.$store.commit("checkAllProductAuthorize",sessionproductAuthorize);//根据sessionStorage替换整个vueX中productWarranty
      }

      var sessionHistoryAuthorize = JSON.parse( sessionStorage.getItem("session_historyAuthorize") );
      if( sessionHistoryAuthorize && sessionHistoryAuthorize.length > 0 ){
        this.$store.commit("checkAllHistoryAuthorize",sessionHistoryAuthorize);//根据sessionStorage替换整个vueX中productWarranty
      }

      var sessionMachineNewOnOff = sessionStorage.getItem("session_machineNewOnOff");
      if( sessionMachineNewOnOff == "true" ){
        this.$store.commit("setMachineNewOnOff",true);
      }else{
        this.$store.commit("setMachineNewOnOff",false);
      }

      this.$store.commit("setPageRefreshOnOff",false);//改变vueX中的setPageRefreshOnOff为false
      // this.getSession();
    },
    mounted(){
      /*tab页右键弹出层，鼠标滑过li选项时的事件start*/
      $(document).off("click", ".contextLists .contextListsSub").on("mouseover", ".contextLists .contextListsSub", function () {
        $(this).addClass("contextListsSubActive");
      });
      $(document).off("click", ".contextLists .contextListsSub").on("mouseout", ".contextLists .contextListsSub", function () {
        $(this).removeClass("contextListsSubActive");
      });
      /*tab页右键弹出层，鼠标滑过li选项时的事件end*/

      /*点击document(除右键弹出层本身),关闭tab页弹出层start*/
      $(document).off("click").on("click",function( event ){
        if( !$( event.target ).hasClass( "contextLists" ) ){
          $(".contextLists").remove();
        }
      });
      /*点击document(除右键弹出层本身),关闭tab页弹出层end*/
    },
    methods: {
      //请求后台的sessionAPI，如果没过期，就跳过登录页
      getSession(){
        var _this = this;

        /*刷新调整--start*/
        $.ajax({
          type: "POST",
          url: "/NetworkTeachSystem/admin/session",
          contentType: "application/json;charset=UTF-8",
          async: false,
          success: function(data){
            //console.log(data);
            var active_iNow = sessionStorage.getItem( "session_active_iNow" );//当前点击的iNow
            var session_login = sessionStorage.getItem( "session_login" );//session_login在点击登陆之后会产生值，所以可以用它来判断未
            if( !data.status ){
              _this.$router.push({path: "/index"});//跳转到登录页
            }else{
              if( !active_iNow && session_login ){//假如session未过期，但是active_iNow没值，说明没有任何导航选中，路由展示初始化引导界面
                var cusRoute = "/main-page";
                _this.$router.push({path: cusRoute});//跳过登录页,跳转至相应路由页面
              }
              if( !active_iNow && !session_login ){//关闭了浏览器，重新打开之前复制的网址，这两个sessionStorage值都为空，就跳转到登录页
                _this.$router.push({path: "/index"});//跳转到登录页
              }
            }
          },
          error: function( XMLHttpRequest, textStatus, errorThrown){
            console.log( textStatus + ":" + XMLHttpRequest.status );
          }
        });
        /*刷新调整----end*/

      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/App.vue